import { fetchApi } from '@/config/axiosSetting';
import { AddAccessoryInitialVisitQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/addAccessoryInitialVisit/addAccessoryInitialVisitQuery.type';

export const addAccessoryInitialVisitFunction = (
  params: AddAccessoryInitialVisitQueryParamsType,
) => {
  return fetchApi.post(
    `/initial/reports/${params.id}/accessory/`,
    params?.data,
    {
      params: {
        id: params?.id,
      },
    },
  );
};
